"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var getMatches = function (query) {
    // Prevents SSR issues
    if (typeof window !== 'undefined') {
        return window.matchMedia(query).matches;
    }
    return false;
};
/**
 * Returns true if the given media query matches.
 * Returns undefined until the first render occured to prevent hydration errors.
 * @param query A media query as string
 * @returns
 */
var useMediaQuery = function (query) {
    var _a = (0, react_1.useState)(getMatches(query)), hasMatch = _a[0], setHasMatches = _a[1];
    var _b = (0, react_1.useState)(true), initialLoad = _b[0], setInitialLoad = _b[1];
    var canUseDOM = !!(typeof window !== 'undefined' &&
        typeof window.document !== 'undefined' &&
        typeof window.document.createElement !== 'undefined');
    var useIsomorphicLayoutEffect = canUseDOM ? react_1.useLayoutEffect : react_1.useEffect;
    useIsomorphicLayoutEffect(function () {
        if (initialLoad) {
            setInitialLoad(false);
        }
    }, []);
    function handleChange() {
        setHasMatches(getMatches(query));
    }
    (0, react_1.useEffect)(function () {
        var matchMedia = window.matchMedia(query);
        handleChange();
        matchMedia.addEventListener('change', handleChange);
        return function () {
            matchMedia.removeEventListener('change', handleChange);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query]);
    return initialLoad ? undefined : hasMatch;
};
exports.default = useMediaQuery;
